document.addEventListener('DOMContentLoaded', () => {
  const marqueeTracks = document.querySelectorAll('.marquee-track');
  marqueeTracks.forEach(track => {
    const content = track.querySelector('.marquee-content');
    const contentWidth = content.offsetWidth;

    // Clone content for seamless looping
    const clone = content.cloneNode(true);
    track.appendChild(clone);

    // Dynamically calculate animation duration
    const duration = contentWidth / 35; // Adjust speed factor
    track.style.setProperty('--marquee-duration', `${duration}s`);

    // Dynamically calculate scroll distance
    track.style.setProperty('--scroll-distance', `${contentWidth}px`);
  });
});